import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";

const Logo = ({ siteLogo }) => (
  <Link to="/" className="flex items-center gap-2">
    {siteLogo ? (
      <img src={siteLogo} alt="TicketsPro.app" className="h-10 w-auto object-contain" />
    ) : (
      <span className="text-2xl font-semibold text-[#16243b]">TicketsPro.app</span>
    )}
  </Link>
);

export default function AuthLayout({ title, subtitle, children }) {
  const [content, setContent] = useState({});
  useEffect(() => {
    api.get("/site-content").then(({ data }) => setContent(data || {})).catch(() => {});
  }, []);
  const hero = content.login_hero_image ||
    "https://giftpro.co.uk/wp-content/uploads/2025/09/fallback-open_voucher-anchor.png";
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-[420px]">
          <Logo siteLogo={content.site_logo} />
          <h1 className="text-[2rem] font-bold text-[#16243b] mt-10">{title}</h1>
          <p className="text-[#5a6b80] mt-2 mb-8">{subtitle}</p>
          {children}
        </div>
      </div>
      <div className="gp-hero-gradient hidden lg:flex items-center justify-center p-12 relative overflow-hidden">
        <div className="relative z-10 max-w-[380px]">
          <img src={hero} alt="Voucher" className="w-full drop-shadow-2xl" data-testid="login-hero-image" />
          <p className="text-white text-[1.3rem] font-medium mt-8 leading-snug text-center">
            {content.footer_tagline || "The hospitality industry\u2019s favourite gift voucher platform."}
          </p>
        </div>
      </div>
    </div>
  );
}
